import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { QualityRule } from '../../../types';

import { getQueryKeyForPolicy } from './useFetchPolicy';

type SaveQualityPolicyRulesParams = {
  policyId: number;
  rules: Array<Partial<QualityRule>>;
};

const putPolicyRules = ({ policyId, rules }: SaveQualityPolicyRulesParams) => {
  return put(`/api/policies/${policyId}/rules`, rules);
};

/**
 * Mutation hook for saving quality policy rules via PUT /api/policies/:policyId/rules.
 * Shows a success or error toast on completion and invalidates the policy query cache.
 *
 * @param {number} policyId - The ID of the policy whose rules are being saved.
 */
export function useSaveQualityPolicyRules(policyId: number) {
  return useToastedMutation({
    mutationFn: putPolicyRules,
    successToastMessage: 'Quality rule(s) saved successfully.',
    errorToastMessage: 'Failed to save quality rules.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeyForPolicy(policyId) });
    },
  });
}
